import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { ScrollToTop } from './scroll-to-top';
import { SiteFooter } from './site-footer';
import { SiteHeader } from './site-header';

export function MarketingLayout() {
  const { t } = useTranslation('marketing');

  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <ScrollToTop />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-sm focus:bg-gold focus:px-4 focus:py-2 focus:text-ink"
      >
        {t('layout.skipToContent')}
      </a>
      <SiteHeader />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
